import React from 'react';

interface LoadingProps {}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & LoadingProps>;

const Loading: Props = ({ className = '', children, ...props }) => {
  return (
    <div
      {...props}
      className={`
        flex
        items-center
        justify-center
        p-16
        ${className}
      `}
    >
      <div
        className={`
          relative
          h-24
          w-[36px]
        `}
      >
        <div
          className="
            absolute
            left-0
            block
            h-0
            w-0
            animate-pulse
            border-t-[12px]
            border-b-[12px]
            border-l-[18px]
            border-t-transparent
            border-b-transparent
            border-l-black
          "
        />
        <div
          className="
            absolute
            right-0
            block
            h-0
            w-0
            animate-pulse
            border-t-[12px]
            border-b-[12px]
            border-r-[18px]
            border-t-transparent
            border-b-transparent
            border-r-black
          "
          style={{ animationDelay: '0.5s' }}
        />
      </div>
    </div>
  );
};

export default Loading;
